export const ClassNames = {
    ListItem: 'list-item',
    ListHeader: 'list-header',
};

export const GridAreaName = 'mf-internal-grid-row-area';
